import { Auth }  from '../../services';
import './authenticator';
import Alert from '../ui/alert';
import events from '../ui/events';
import Profile from './profile';

const markup = `<db:identity>
	<span data-id='name'>Anonymous</span>
	<span data-id='login' class='action'>Login</span>
	<span data-id='logout' class='action'>Logout</span>
	<db:authenticator data-id='authenticator'></db:authenticator>
</db:identity>`;

export default DomClass(markup, function () {
	var _t = this;

	this.user = {};

	this.refresh = () => {
		window.user = this.user;
		if (this.user.username) {
			this.classList.add('authenticated');
		} else {
			this.classList.remove('authenticated');
		}
		this.name = this.user.username || 'Anonymous';
		on(events, 'identityChange').fire(this.user);
	};

	this.__dom.login.onclick = () => {
		this.authenticator.open();
	};

	this.__dom.logout.onclick = () => {
		const spinner = new Spinner({
			message: "Logging out ..."
		});
		spinner.open();

		Auth.signOut().then(() => {
			spinner.close();
			_t.user = {};
			_t.refresh();
		}).catch(error => {
			spinner.close();
			new Alert("Failure signing out. Refresh and try again.");
			console.error("Failure signing out.", error);
		});
	};

	this.__dom.name.onclick = () => {
		const profile = new Profile();
		profile.open();
	};

	on(this.authenticator, 'login').then(user => {
		_t.user = user;
		_t.refresh();
	});

	Auth.currentAuthenticatedUser().then(user => {
		if (user && user.username !== this.user.username) {
			this.user = user || {};
			this.refresh();
		}
	}).catch(error => {
		// no authenticated.
		if (this.user.username) {
			this.user = {};
			this.refresh();
		}
	});

});
